<template>
    <layout>
        <component v-if="componentLoaded" is="inspection-template" ref="template" :inspection="inspection" @save="save" @submit="submit" @approve="approve" @reject="reject"></component>

    </layout>
</template>

<script>
    import roleMixin from '../../mixins/role-mixins.js';

    const inspectionsIncludeStr = 'include=status,region,contact,inspector'
    import Vue from 'vue';

    export default {
        mixins: [ roleMixin ],
        name: 'inspection-editor',
        data () {
            return {
                componentLoaded: false,
                inspection: this.$schema.map('inspection', { inspection: null }),
            };
        },
        components: {
            layout: require('../layouts/default.vue'),
        },
        methods: {
            save (data) {
                this.$planner.busy(true);

                // FIXME: Does not properly support arrays.  Not needed at the present.
                function difference(object, base) {
                    function changes(object, base) {
                        return _.transform(object, function(result, value, key) {
                            if (!_.isEqual(value, base[key])) {
                                result[key] = (_.isObject(value) && !Array.isArray(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                            }
                        });
                    }
                    return changes(object, base);
                }

                let delta = difference(data, this.inspection.data);

                this.axios.put(`inspections/${this.inspection.id}?${inspectionsIncludeStr}`, { data: JSON.stringify(delta) }).then((response) => {
                    // Decode json data into JS object
                    // response.data.data = JSON.parse(response.data.data);

                    this.inspection = response.data;
                    this.$toasted.success('Inspection updated!');
                    this.$planner.busy(false);
                });
            },
            submit () {
                this.$planner.busy(true);
                this.axios.post(`inspections/${this.inspection.id}/submit?${inspectionsIncludeStr}`)
                .then((response) => {

                    this.inspection = response.data;
                    this.showAlert('Inspection submitted!');
                    this.$planner.busy(false);
                }).catch((error) => {

                });
            },
            approve () {
                this.$planner.busy(true);
                this.axios.post(`inspections/${this.inspection.id}/validate?${inspectionsIncludeStr}`)
                .then((response) => {

                    this.inspection = response.data;
                    this.showAlert('Inspection approved!', 'Please keep a copy of the 004 for your future reference');
                    this.$planner.busy(false);

                }).catch((error) => {

                });
            },
            reject () {
                this.$planner.busy(true);
                this.axios.post(`inspections/${this.inspection.id}/reject?${inspectionsIncludeStr}`)
                .then((response) => {

                    this.inspection = response.data;
                    this.showAlert('Inspection rejected!');
                    this.$planner.busy(false);

                }).catch((error) => {

                });
            },
            showAlert(text, text2 = ''){
                // Use sweetalret2
                this.$swal(text, text2, 'success');
            }
        },

        created () {
            let templateId = 'default1';

            this.axios.get(`inspections/${this.$route.params.id}?${inspectionsIncludeStr}`).then((response) => {
                // Decode json data into JS object
                //response.data.data = JSON.parse(response.data.data);

                this.inspection = Object.assign(response.data, {template_id: templateId});

                this.$options.components['inspection-template'] = () => import('../async/inspections/inspection-' + templateId /* this.plan.template_id */ + '.vue');
                this.componentLoaded = true;
            });
        },

        beforeRouteLeave (to, from, next) {
            // Prompt user to save / discard changes
            // If user agrees, save work and call next()
            // Else next()
            if(this.componentLoaded && this.$refs.template.hasEdits) {
                this.$swal({
                    title: 'Save changes?',
                    text: 'You have unsaved changes',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Save',
                    cancelButtonText: 'Discard'

                    }).then((result) => {
                        if (result.value) {
                            this.$refs.template.save(); // FIXME: save flow should return a promise and then exit
                            next();
                        } else {
                            next();
                        }
                })
            } else {
                next();
            }
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// inspections-editor.vue?aea0063a